import { TextField } from "@root/shared/components/TextField";
import { Button } from "@root/shared/components/Button";
import { ErrorInformationText } from "@root/userFrontend/components/ErrorInformationText";
import { useStep1Form } from "@userFrontend/features/registration/hooks/useStep1Form";
import { Step1HiddenForm } from "@userFrontend/features/registration/components/Step1HiddenForm";
import * as styles from "./styles.css";

export type Step1FormProps = {
  action: string;
  emailDuplicateCheckPath: string;
  gaAction: string;
  gaLabel: string;
  defaultEmailErrorMessages?: string[];
  defaultPasswordErrorMessages?: string[];
};

export const Step1Form = (props: Step1FormProps) => {
  const {
    action,
    emailDuplicateCheckPath,
    gaAction,
    gaLabel,
    defaultEmailErrorMessages,
    defaultPasswordErrorMessages,
  } = props;

  const { formRef, email, password, handleSubmitButtonClick, isSubmitButtonDisabled } =
    useStep1Form({
      emailDuplicateCheckPath,
      defaultEmailErrorMessages,
      defaultPasswordErrorMessages,
    });

  return (
    <>
      <Step1HiddenForm
        formRef={formRef}
        action={action}
        emailValue={email.value}
        passwordValue={password.value}
      />
      <div className={styles.container}>
        <div className={styles.fieldContainer}>
          <label htmlFor="email" className={styles.label}>
            メールアドレス
          </label>
          <TextField {...email.register} id="email" type="email" placeholder="sample@email.com" />
          <div role="region" aria-label="メールアドレスのエラー">
            {email.errorMessages.map((msg) => (
              <ErrorInformationText key={msg} text={msg} />
            ))}
          </div>
        </div>
        <div className={styles.fieldContainer}>
          <label htmlFor="password" className={styles.label}>
            パスワード
          </label>
          <TextField
            {...password.register}
            id="password"
            type="password"
            placeholder="パスワード/8文字以上の半角英数字"
          />
          <div role="region" aria-label="パスワードのエラー">
            {password.errorMessages.map((msg) => (
              <ErrorInformationText key={msg} text={msg} />
            ))}
          </div>
        </div>
        <Button
          type="button"
          onClick={handleSubmitButtonClick}
          size="large"
          theme={isSubmitButtonDisabled ? "disabled" : "primary"}
          className={styles.submitButton}
          disabled={isSubmitButtonDisabled}
          data-ga-action={gaAction}
          data-ga-label={gaLabel}
        >
          カンタン登録
        </Button>
      </div>
    </>
  );
};
